import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";

import App from "./App.vue";
import store from "./store/";
import router from "./router";
import VueTheMask from "vue-the-mask";

import "./plugins/vuetify";
import "./plugins/vue-currency-filter";
import "./filters/formatDate";

import { Unijs } from "@unimed/unijs/components";

Vue.use(Unijs);

Vue.config.productionTip = false;

new Vue({
  VueAxios,
  axios,
  store,
  router,
  VueTheMask,
  render: h => h(App)
}).$mount("#app");
